import React from 'react';
export function PriceSection() {
  return <section id="precio" className="w-full bg-cream-dark py-20 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        {/* Badge */}
        <div className="text-center mb-8" data-id="element-131">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-rose-gold text-white text-sm font-bold tracking-wider uppercase" data-id="element-132">
            OFERTA DE LANZAMIENTO
          </div>
        </div>

        {/* Combined Card */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-rose-gold/20" data-id="element-133">
          {/* Value Table */}
          <div className="overflow-x-auto" data-id="element-134">
            <table className="w-full text-left border-collapse" data-id="element-135">
              <thead data-id="element-136">
                <tr className="bg-brown-primary text-cream" data-id="element-137">
                  <th className="py-4 px-6 font-serif text-lg font-normal" data-id="element-138">
                    Elemento
                  </th>
                  <th className="py-4 px-6 font-serif text-lg font-normal text-right" data-id="element-139">
                    Valor Real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-cream-dark" data-id="element-140">
                <tr data-id="element-141">
                  <td className="py-4 px-6 text-brown-primary font-medium" data-id="element-142">
                    Método Piel de Vidrio (Guía Maestra)
                  </td>
                  <td className="py-4 px-6 text-brown-secondary text-right" data-id="element-143">
                    $27.00 USD
                  </td>
                </tr>
                <tr data-id="element-144">
                  <td className="py-4 px-6 text-brown-primary font-medium" data-id="element-145">
                    Bono 1: Checklist de Farmacia
                  </td>
                  <td className="py-4 px-6 text-brown-secondary text-right" data-id="element-146">
                    $9.00 USD
                  </td>
                </tr>
                <tr data-id="element-147">
                  <td className="py-4 px-6 text-brown-primary font-medium" data-id="element-148">
                    Bono 2: Calendario 14 Días
                  </td>
                  <td className="py-4 px-6 text-brown-secondary text-right" data-id="element-149">
                    $9.00 USD
                  </td>
                </tr>
                <tr data-id="element-150">
                  <td className="py-4 px-6 text-brown-primary font-medium" data-id="element-151">
                    Bono 3: Guía SOS Anti-Irritación
                  </td>
                  <td className="py-4 px-6 text-brown-secondary text-right" data-id="element-152">
                    $9.00 USD
                  </td>
                </tr>
                <tr className="bg-cream-dark/50" data-id="element-153">
                  <td className="py-4 px-6 text-brown-primary font-bold uppercase tracking-wider text-sm" data-id="element-154">
                    VALOR TOTAL
                  </td>
                  <td className="py-4 px-6 text-brown-secondary text-right font-bold line-through" data-id="element-155">
                    $54.00 USD
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Price + CTA */}
          <div className="bg-rose-gold/5 border-t border-rose-gold/20 p-8 md:p-10 text-center" data-id="element-156">
            <p className="text-lg text-brown-secondary/60 mb-1 font-medium line-through" data-id="element-157">
              $54.00 USD
            </p>
            <h2 className="text-4xl md:text-6xl font-bold text-brown-primary mb-2 font-serif" data-id="element-158">
              PRECIO DE HOY:{' '}
              <span className="text-white bg-rose-gold px-4 py-1.5 rounded-md inline-block mt-2" data-id="element-159">
                $9.00 USD
              </span>
            </h2>

            <p className="text-lg text-brown-secondary mb-8 font-medium tracking-wide mt-4" data-id="element-160">
              Acceso inmediato. PDF + Audio. Sin suscripciones.
            </p>

            <a href="https://pay.hotmart.com/U104512405G?off=q88xj3ms&checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={() => {
            if ((window as any).fbq) {
              ;
              (window as any).fbq('track', 'AddToCart');
            }
          }} className="w-full md:w-auto px-12 py-5 bg-rose-gold hover:bg-rose-dark text-white text-xl font-bold tracking-wide rounded-sm transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 inline-block text-center" data-id="element-161">
              ¡SÍ, QUIERO MI PIEL DE VIDRIO POR $9 USD!
            </a>
          </div>
        </div>
      </div>
    </section>;
}